module.exports = __webpack_public_path__ + "img/email.5c305eb2.svg";